module.exports = "https://static.wmbcdn.com/uniweb/images/af27d9f3070afd2b88522e4f14384be0.svg";